import React, {Component} from "react";

/**
 * Inline progress for the CoPilot's own calls.
 *
 * The app-wide LoadingComponent is a full-page redux overlay driven by
 * RemotingService's operation counter; the recommender is called through its own axios
 * client and must not block the page, so this reuses the app's `.loader` spinner
 * (components/loading/LoadingComponent.css) inline instead.
 *
 * The captions are not fake progress: they name the stages the request actually goes
 * through, which is what makes a multi-second AI call feel accounted for rather than hung.
 */
const STEP_MS = 1900;

export default class LoadingSteps extends Component {

    state = {step: 0};

    componentDidMount() {
        this.timer = setInterval(() => {
            // Hold on the last caption rather than looping: a repeating list reads as
            // "stuck in a cycle" once the call runs long.
            this.setState(state => {
                const last = (this.props.messages || []).length - 1;
                return state.step >= last ? null : {step: state.step + 1};
            });
        }, STEP_MS);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const messages = this.props.messages || [];
        return (
            <div className="emr-check-loading">
                <div className="loader emr-check-loader"/>
                <div className="emr-check-loading-text" key={this.state.step}>
                    {messages[this.state.step]}
                </div>
            </div>
        );
    }
}
